// TODO: resolve dependency cycle
import LifecyclePicker from 'application/Shared/Components/Pickers/Lifecycle';
import { LifecycleStatus } from 'application/Shared/Constants';
import i18n from 'i18n';
import React from 'react';

const { t } = i18n;

const filterableOptions = [
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.Unapproved}`),
        parameter: 'status',
        render: (
            <LifecyclePicker visualOnly value={LifecycleStatus.Unapproved} />
        ),
        value: LifecycleStatus.Unapproved
    },
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.NotConfigured}`),
        parameter: 'status',
        render: (
            <LifecyclePicker visualOnly value={LifecycleStatus.NotConfigured} />
        ),
        value: LifecycleStatus.NotConfigured
    },
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.Evaluating}`),
        parameter: 'status',
        render: (
            <LifecyclePicker visualOnly value={LifecycleStatus.Evaluating} />
        ),
        value: LifecycleStatus.Evaluating
    },
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.Implementing}`),
        parameter: 'status',
        render: (
            <LifecyclePicker visualOnly value={LifecycleStatus.Implementing} />
        ),
        value: LifecycleStatus.Implementing
    },
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.Approved}`),
        parameter: 'status',
        render: <LifecyclePicker visualOnly value={LifecycleStatus.Approved} />,
        value: LifecycleStatus.Approved
    },
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.Decommissioning}`),
        parameter: 'status',
        render: (
            <LifecyclePicker
                visualOnly
                value={LifecycleStatus.Decommissioning}
            />
        ),
        value: LifecycleStatus.Decommissioning
    },
    {
        name: t(`Picker.lifecycle.${LifecycleStatus.Decommissioned}`),
        parameter: 'status',
        render: (
            <LifecyclePicker
                visualOnly
                value={LifecycleStatus.Decommissioned}
            />
        ),
        value: LifecycleStatus.Decommissioned
    }
];

const headers = {
    filterable: true,
    filterableOptions,
    name: 'Common.lifecycle',
    sortable: true,
    sortableFieldType: 'string',
    sortableKey: 'status',
    tooltip: 'lifecycle_stage',
    width: '10%'
};

export default headers;
